import moment, { Moment } from 'moment'
import {
  LanguageLinks,
  ParsedLanguageLinks,
  Language,
  EntityOperation,
  ParsedEntityOperation,
  EntityOperations,
  ParsedEntityOperations,
  IntegerItem,
  FieldItemList,
  UuidItem,
  LanguageItem,
  EntityReferenceNodeTypeItem,
  ParsedEntityReferenceNodeTypeItem,
  TimestampItem,
  EntityReferenceUserItem,
  ParsedEntityReferenceUserItem,
  StringItem,
  BooleanItem,
  MetatagField,
  Metatags,
  PathItem,
  ListStringItem,
  NodeBase,
  ParsedNodeBase,
  LinkItem,
  ParsedLinkItem,
  EntityReferenceTaxonomyVocabularyItem,
  ParsedEntityReferenceTaxonomyVocabularyItem,
  TextItem,
  EntityReferenceTaxonomyTermWithTargetItem,
  ParsedTaxonomyTerm,
  TaxonomyTermBase,
  ParsedTaxonomyTermBase,
  TaxonomyTermPageType,
  ParsedTaxonomyTermPageType,
  TaxonomyTerm,
  EmailItem,
  TaxonomyTermPressContact,
  ParsedTaxonomyTermPressContact,
  TaxonomyTermRelatedContent,
  ParsedTaxonomyTermRelatedContent,
  Entity,
  EntityReferenceTaxonomyTermWithTargetNodeCareerFieldCategoryItem,
  EntityReferenceMediaTypeItem,
  ParsedEntityReferenceMediaTypeItem,
  FileUriItem,
  FileBase,
  ParsedFileBase,
  Styles,
  ParsedStyles,
  FileImage,
  ParsedFileImage,
  File,
  FileOther,
  ParsedFileOther,
  ParsedFile,
  ImageFileWithTargetItem,
  ParsedImageFileWithTargetItem,
  MediaBase,
  ParsedMediaBase,
  FileFileWithTargetItem,
  ParsedFileFileWithTargetItem,
  MediaDocument,
  ParsedMediaDocument,
  Media,
  MediaImage,
  ParsedMediaImage,
  VideoEmbedFieldItem,
  ParsedVideoEmbedFieldItem,
  MediaVideo,
  ParsedMediaVideo,
  ParsedMedia,
  EntityReferenceMediaWithTargetNodeCareerFieldIntroductionImageItem,
  MetatagItem,
  EntityReferenceParagraphsTypeItem,
  ParsedEntityReferenceParagraphsTypeItem,
  ParagraphBase,
  ParsedParagraphBase,
  EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldImageItem,
  EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldPreviewImageItem,
  Paragraph360BuildingBlock,
  ParsedParagraph360BuildingBlock,
  Paragraph,
  TextWithSummaryItem,
  ParsedTextWithSummaryItem,
  FilterFormat,
  ParagraphAdressBlock,
  ParsedParagraphAdressBlock,
  CampaignMonitorItem,
  ParagraphCampaignManager,
  ParsedParagraphCampaignManager,
  EntityReferenceTaxonomyTermWithTargetParagraphCategoryFieldCategoryItem,
  ParagraphCategory,
  ParsedParagraphCategory,
  EntityReferenceMediaWithTargetParagraphContactFieldImageItem,
  ParagraphContact,
  ParsedParagraphContact,
  EntityReferenceMediaWithTargetParagraphCtaFieldImageItem,
  ParagraphCta,
  ParsedParagraphCta,
  EntityReferenceMediaWithTargetParagraphCtaWithImageFieldImageItem,
  ParagraphCtaWithImage,
  ParsedParagraphCtaWithImage,
  EntityReferenceMediaWithTargetParagraphDevelopmentBlockFieldImagesItem,
  ParagraphDevelopmentBlock,
  ParsedParagraphDevelopmentBlock,
  EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldImageItem,
  EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldSecondaryImageItem,
  ParagraphDoubleTextWithImage,
  ParsedParagraphDoubleTextWithImage,
  EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem,
  ParagraphDownloadList,
  ParsedParagraphDownloadList,
  EntityReferenceMediaWithTargetParagraphDownloadListNestedFieldDownloadItem,
  ParagraphDownloadListNested,
  ParsedParagraphDownloadListNested,
  EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem,
  ParagraphDownloads,
  ParsedParagraphDownloads,
  EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsNestedFieldDownloadListNestedItem,
  ParagraphDownloadsNested,
  ParsedParagraphDownloadsNested,
  EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlockFieldContentBlockItem,
  ParsedParagraphQuoteNested,
  ParsedParagraphOffice,
  ParsedParagraphMediaNested,
  ParsedParagraphTextNested,
  ParagraphQuoteNested,
  ParagraphOffice,
  ParagraphMediaNested,
  ParagraphTextNested,
  EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem,
  ParagraphExpandableContentBlock,
  ParsedParagraphExpandableContentBlock,
  EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem,
  ParagraphExpandableContentBlocks,
  ParsedParagraphExpandableContentBlocks,
  EntityReferenceRevisionsParagraphWithTargetParagraphExtraNavigationalElementFieldExtraElementsItem,
  ParsedParagraphGridBlocksImage,
  ParagraphGridBlocksImage,
  ParagraphExtraNavigationalElement,
  ParsedParagraphExtraNavigationalElement,
  EntityReferenceNodeWithTargetParagraphFeaturedContentFieldFeaturedContentItem,
  ParsedNodePage,
  NodePage,
  ParagraphFeaturedContent,
  ParsedParagraphFeaturedContent,
  FormListItem,
  ParagraphForm,
  ParsedParagraphForm,
  EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem,
  ParagraphGridBlockImage,
  ParsedParagraphGridBlockImage,
  ParagraphGridBlockPlain,
  ParsedParagraphGridBlockPlain,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem,
  ParagraphGridBlocksPlain,
  ParsedParagraphGridBlocksPlain,
  ParagraphHubspotForm,
  ParsedParagraphHubspotForm,
  ParagraphIcon,
  ParsedParagraphIcon,
  ParagraphIconWithText,
  ParsedParagraphIconWithText,
  ParagraphIframe,
  ParsedParagraphIframe,
  ParagraphIframeCode,
  ParsedParagraphIframeCode,
  EntityReferenceMediaWithTargetParagraphImageFieldImageItem,
  ParagraphImage,
  ParsedParagraphImage,
  EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem,
  ParagraphImageGallery,
  ParsedParagraphImageGallery,
  ParagraphJobAlert,
  ParsedParagraphJobAlert,
  ParagraphLinkListItem,
  ParsedParagraphLinkListItem,
  EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem,
  ParagraphLinksList,
  ParsedParagraphLinksList,
  ParagraphMagazineEmbed,
  ParsedParagraphMagazineEmbed,
  EntityReferenceRevisionsParagraphWithTargetParagraphMediaFieldMediaItemItem,
  ParsedParagraphMediaItem,
  ParagraphMediaItem,
  ParagraphMedia,
  ParsedParagraphMedia,
  EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem,
  EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem,
  ParagraphMediaItemNested,
  ParsedParagraphMediaItemNested,
  EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem,
  EntityReferenceTaxonomyTermWithTargetParagraphPressFieldContactPersonItem,
  ParagraphPress,
  ParsedParagraphPress,
  ParagraphPressReleases,
  ParsedParagraphPressReleases,
  ParagraphQuote,
  ParsedParagraphQuote,
  EntityReferenceMediaWithTargetParagraphQuoteWithImageFieldImageItem,
  ParagraphQuoteWithImage,
  ParsedParagraphQuoteWithImage,
  ParagraphRelatedContentLoadMore,
  ParsedParagraphRelatedContentLoadMore,
  ParagraphStoriesGrid,
  ParsedParagraphStoriesGrid,
  ParagraphText,
  ParsedParagraphText,
  EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem,
  ParagraphTextWithImage,
  ParsedParagraphTextWithImage,
  EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem,
  ParagraphTextWithReadMore,
  ParsedParagraphTextWithReadMore,
  EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem,
  ParsedParagraphTimelineItem,
  ParagraphTimelineItem,
  ParagraphTimeline,
  ParsedParagraphTimeline,
  EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem,
  ParagraphUpdates,
  ParsedParagraphUpdates,
  ParsedParagraph,
  EntityReferenceRevisionsParagraphWithTargetNodeCareerFieldPageContentItem,
  NodeCareer,
  ParsedNodeCareer,
  Node,
  EntityReferenceTaxonomyTermWithTargetNodeCaseFieldCategoryItem,
  EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldIconItem,
  EntityReferenceMediaWithTargetNodeCaseFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldPageContentItem,
  NodeCase,
  ParsedNodeCase,
  EntityReferenceMediaWithTargetNodeContactFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeContactFieldPageContentItem,
  NodeContact,
  ParsedNodeContact,
  EntityReferenceTaxonomyTermWithTargetNodeExpertiseFieldCategoryItem,
  EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldIconItem,
  EntityReferenceMediaWithTargetNodeExpertiseFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldPageContentItem,
  NodeExpertise,
  ParsedNodeExpertise,
  EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldIconsItem,
  EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem,
  NodeHomepage,
  ParsedNodeHomepage,
  EntityReferenceTaxonomyTermWithTargetNodePageFieldCategoryItem,
  EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem,
  EntityReferenceTaxonomyTermWithTargetNodeProjectFieldCategoryItem,
  EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldIconsItem,
  EntityReferenceMediaWithTargetNodeProjectFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldPageContentItem,
  NodeProject,
  ParsedNodeProject,
  EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem,
  NodeStory,
  ParsedNodeStory,
  EntityReferenceTaxonomyTermWithTargetNodeUpdateFieldCategoryItem,
  EntityReferenceMediaWithTargetNodeUpdateFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeUpdateFieldPageContentItem,
  NodeUpdate,
  ParsedNodeUpdate,
  EntityReferenceMediaWithTargetNodeUpdateOverviewFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeUpdateOverviewFieldPageContentOptionalItem,
  NodeUpdateOverview,
  ParsedNodeUpdateOverview,
  ParsedNode,
  EntityReferenceConfigPagesTypeItem,
  ParsedEntityReferenceConfigPagesTypeItem,
  ConfigPagesBase,
  ParsedConfigPagesBase,
  ConfigPagesCookiebar,
  ParsedConfigPagesCookiebar,
  ConfigPages,
  ConfigPagesFooter,
  ParsedConfigPagesFooter,
  ConfigPagesPress,
  ParsedConfigPagesPress,
  ConfigPagesPressDutch,
  ParsedConfigPagesPressDutch,
  ConfigPagesPreviewLink,
  ParsedConfigPagesPreviewLink,
  ParsedConfigPages,
  InputEntity,
  ParsedInputEntity,
  ParsedEntity
} from './types.ext.gen'
import {
  Map,
  OrderedMap,
  List
} from 'immutable'


export const noop_parser = <T>(t: T): T => t

export const language_links_parser = (l: LanguageLinks): ParsedLanguageLinks => Map<Language, string>(l)

export const entity_operation_parser = (t: EntityOperation): ParsedEntityOperation => ({
  title: t.title,
  url: t.url
})

export const entity_operations_parser = (l: EntityOperations | undefined): ParsedEntityOperations => l ? OrderedMap<string, EntityOperation>(l).sortBy(o => (o as EntityOperation).weight).map(o => entity_operation_parser(o as EntityOperation)).toOrderedMap() : OrderedMap<string, EntityOperation>()

export const integer_item_parser = (t: IntegerItem): number => noop_parser<number>(t.value)

export const singular_optional_integer_parser = (f: FieldItemList<IntegerItem>): number | null => f && f.length > 0 ? integer_item_parser(f[0]) : null

export const uuid_item_parser = (t: UuidItem): string => noop_parser<string>(t.value)

export const singular_optional_uuid_parser = (f: FieldItemList<UuidItem>): string | null => f && f.length > 0 ? uuid_item_parser(f[0]) : null

export const language_item_parser = (t: LanguageItem): Language => t.value

export const singular_optional_language_parser = (f: FieldItemList<LanguageItem>): Language | null => f && f.length > 0 ? language_item_parser(f[0]) : null

export const entity_reference_node_type_item_parser = (t: EntityReferenceNodeTypeItem): ParsedEntityReferenceNodeTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_node_type_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): ParsedEntityReferenceNodeTypeItem => entity_reference_node_type_item_parser(f[0])

export const node_bundle_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): string => f[0].target_id

export const moment_parser = (t: string): Moment => moment.utc(t).local()

export const required_date_time_parser = (t: string): Moment => moment_parser(t)

export const timestamp_item_parser = (t: TimestampItem): Moment => required_date_time_parser(t.value)

export const singular_optional_created_parser = (f: FieldItemList<TimestampItem>): Moment | null => f?.length > 0 ? timestamp_item_parser(f[0]) : null

export const entity_reference_user_item_parser = (t: EntityReferenceUserItem): ParsedEntityReferenceUserItem => ({
  id: noop_parser<number>(t.target_id),
  url: t.url,
  label: t.target_label
})

export const singular_optional_entity_reference_user_parser = (f: FieldItemList<EntityReferenceUserItem>): ParsedEntityReferenceUserItem | null => f && f.length > 0 ? entity_reference_user_item_parser(f[0]) : null

export const string_item_parser = (t: StringItem): string => noop_parser<string>(t.value)

export const singular_optional_string_long_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const boolean_item_parser = (t: BooleanItem): boolean => noop_parser<boolean>(t.value)

export const singular_optional_boolean_parser = (f: FieldItemList<BooleanItem>): boolean | null => f && f.length > 0 ? boolean_item_parser(f[0]) : null

export const singular_required_string_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const singular_optional_changed_parser = (f: FieldItemList<TimestampItem>): Moment | null => f?.length > 0 ? timestamp_item_parser(f[0]) : null

export const singular_optional_string_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const metatag_field_parser = (t: MetatagField): Metatags => t ? (t.value) : {}

export const path_item_parser = (t: PathItem): string | null => noop_parser<string | null>(t.alias)

export const singular_optional_path_parser = (f: FieldItemList<PathItem> | undefined): string | null => f && f.length > 0 ? path_item_parser(f[0]) : null

export const singular_optional_timestamp_parser = (f: FieldItemList<TimestampItem>): Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const list_string_item_parser = (t: ListStringItem): string => noop_parser<string>(t.value)

export const singular_optional_list_string_parser = (f: FieldItemList<ListStringItem>): string | null => f && f.length > 0 ? list_string_item_parser(f[0]) : null

export const node_base_parser = (t: NodeBase): ParsedNodeBase => ({
  entity_type: ((_: any): "node" => "node")(t),
  id: singular_optional_integer_parser(t.nid),
  status: singular_optional_boolean_parser(t.status),
  author: singular_optional_entity_reference_user_parser(t.uid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.title),
  revision_timestamp: singular_optional_created_parser(t.revision_timestamp),
  revision_uid: singular_optional_entity_reference_user_parser(t.revision_uid),
  revision_log: singular_optional_string_long_parser(t.revision_log),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  promote: singular_optional_boolean_parser(t.promote),
  sticky: singular_optional_boolean_parser(t.sticky),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  moderation_state: singular_optional_string_parser(t.moderation_state),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  content_translation_source: singular_optional_language_parser(t.content_translation_source),
  content_translation_outdated: singular_optional_boolean_parser(t.content_translation_outdated),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const link_item_parser = (t: LinkItem): ParsedLinkItem => ({
  title: noop_parser<string | null>(t.title),
  url: t.processed_url
})

export const singular_optional_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem | null => f && f.length > 0 ? link_item_parser(f[0]) : null

export const entity_reference_taxonomy_vocabulary_item_parser = (t: EntityReferenceTaxonomyVocabularyItem): ParsedEntityReferenceTaxonomyVocabularyItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_taxonomy_vocabulary_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): ParsedEntityReferenceTaxonomyVocabularyItem => entity_reference_taxonomy_vocabulary_item_parser(f[0])

export const taxonomy_term_bundle_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): string => f[0].target_id

export const text_item_parser = (t: TextItem): string => t.processed

export const singular_optional_text_long_parser = (f: FieldItemList<TextItem>): string | null => f && f.length > 0 ? text_item_parser(f[0]) : null

export const entity_reference_taxonomy_term_with_target_item_parser = (t: EntityReferenceTaxonomyTermWithTargetItem): ParsedTaxonomyTerm | undefined | undefined => (t.target !== undefined ? taxonomy_term_parser(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetItem => (t.target_id !== undefined) && ((t.target === undefined) || taxonomy_term_guard(t.target))

export const plural_entity_reference_taxonomy_term_with_target_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetItem>): List<ParsedTaxonomyTerm> =>
    List<ParsedTaxonomyTerm>(f.filter(i => entity_reference_taxonomy_term_with_target_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_item_parser(i)).filter(i => i !== undefined))

export const taxonomy_term_base_parser = (t: TaxonomyTermBase): ParsedTaxonomyTermBase => ({
  entity_type: ((_: any): "taxonomy_term" => "taxonomy_term")(t),
  id: singular_optional_integer_parser(t.tid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  description: singular_optional_text_long_parser(t.description),
  weight: singular_optional_integer_parser(t.weight),
  parent: plural_entity_reference_taxonomy_term_with_target_parser(t.parent),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  content_translation_source: singular_optional_language_parser(t.content_translation_source),
  content_translation_outdated: singular_optional_boolean_parser(t.content_translation_outdated),
  content_translation_uid: singular_optional_entity_reference_user_parser(t.content_translation_uid),
  content_translation_created: singular_optional_created_parser(t.content_translation_created),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const taxonomy_term_page_type_parser = (t: TaxonomyTermPageType): ParsedTaxonomyTermPageType => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "page_type" => "page_type")(t.vid)
})

export const taxonomy_term_page_type_guard = (t: TaxonomyTerm): t is TaxonomyTermPageType => taxonomy_term_bundle_parser(t.vid) == "page_type"

export const email_item_parser = (t: EmailItem): string => noop_parser<string>(t.value)

export const plural_email_parser =
  (f: FieldItemList<EmailItem>): List<string> =>
    List<string>(f.map(i => email_item_parser(i)))

export const plural_telephone_parser =
  (f: FieldItemList<StringItem>): List<string> =>
    List<string>(f.map(i => string_item_parser(i)))

export const taxonomy_term_press_contact_parser = (t: TaxonomyTermPressContact): ParsedTaxonomyTermPressContact => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "press_contact" => "press_contact")(t.vid),
  field_designation: singular_optional_string_parser(t.field_designation),
  field_email: plural_email_parser(t.field_email),
  field_phone_number: plural_telephone_parser(t.field_phone_number)
})

export const taxonomy_term_press_contact_guard = (t: TaxonomyTerm): t is TaxonomyTermPressContact => taxonomy_term_bundle_parser(t.vid) == "press_contact"

export const taxonomy_term_related_content_parser = (t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "related_content" => "related_content")(t.vid)
})

export const taxonomy_term_related_content_guard = (t: TaxonomyTerm): t is TaxonomyTermRelatedContent => taxonomy_term_bundle_parser(t.vid) == "related_content"

export const taxonomy_term_parser = (t: TaxonomyTerm): ParsedTaxonomyTerm =>
  taxonomy_term_page_type_guard(t) ?
    taxonomy_term_page_type_parser(t) :
  taxonomy_term_press_contact_guard(t) ?
    taxonomy_term_press_contact_parser(t) :
    taxonomy_term_related_content_parser(t)

export const taxonomy_term_guard = (t: Entity): t is TaxonomyTerm => (
  (t as any).tid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).vid[0].target_type == "taxonomy_vocabulary" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).name !== undefined &&
  (t as any).description !== undefined &&
  (t as any).weight !== undefined &&
  (t as any).parent !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined &&
  (t as any).content_translation_source !== undefined &&
  (t as any).content_translation_outdated !== undefined &&
  (t as any).content_translation_uid !== undefined &&
  (t as any).content_translation_created !== undefined
)

export const entity_reference_taxonomy_term_with_target_node_career_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodeCareerFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_career_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodeCareerFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_career_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodeCareerFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_career_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_career_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_type_item_parser = (t: EntityReferenceMediaTypeItem): ParsedEntityReferenceMediaTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_media_type_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): ParsedEntityReferenceMediaTypeItem => entity_reference_media_type_item_parser(f[0])

export const media_bundle_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): string => f[0].target_id

export const file_uri_item_parser = (t: FileUriItem): string | null => noop_parser<string | null>(t.url)

export const singular_optional_file_uri_parser = (f: FieldItemList<FileUriItem>): string | null => f && f.length > 0 ? file_uri_item_parser(f[0]) : null

export const file_base_parser = (t: FileBase): ParsedFileBase => ({
  entity_type: ((_: any): "file" => "file")(t),
  id: singular_optional_integer_parser(t.fid),
  label: singular_optional_string_parser(t.filename),
  url: singular_optional_file_uri_parser(t.uri)
})

export const styles_parser = (t: Styles): ParsedStyles => ({
  "1100x1100": t["1100x1100"],
  "1280w": t["1280w"],
  "1280x1280": t["1280x1280"],
  "1280x720": t["1280x720"],
  "1360x680": t["1360x680"],
  "1440w": t["1440w"],
  "1440x720": t["1440x720"],
  "1440x900": t["1440x900"],
  "1600x1200": t["1600x1200"],
  "175x175": t["175x175"],
  "1920w": t["1920w"],
  "1920x1920": t["1920x1920"],
  "2720x1360": t["2720x1360"],
  "280x280": t["280x280"],
  "2880w": t["2880w"],
  "320x320": t["320x320"],
  "345x345": t["345x345"],
  "360x360": t["360x360"],
  "400x300": t["400x300"],
  "480x300": t["480x300"],
  "555x555": t["555x555"],
  "560x280": t["560x280"],
  "580x580": t["580x580"],
  "600w": t["600w"],
  "640w": t["640w"],
  "640x360": t["640x360"],
  "640x640": t["640x640"],
  "680x340": t["680x340"],
  "690x690": t["690x690"],
  "720w": t["720w"],
  "720x360": t["720x360"],
  "720x720": t["720x720"],
  "800w": t["800w"],
  "800x600": t["800x600"],
  "960x600": t["960x600"],
  crop_thumbnail: t.crop_thumbnail,
  grid: t.grid,
  large: t.large,
  media: t.media,
  medium: t.medium,
  text_with_image: t.text_with_image,
  thumbnail: t.thumbnail
})

export const file_image_parser = (t: FileImage): ParsedFileImage => ({
  ...file_base_parser(t),
  style_urls: (t.style_urls !== undefined ? styles_parser(t.style_urls) : undefined)
})

export const file_image_guard = (t:File): t is FileImage => (t as any).style_urls !== undefined

export const file_other_parser = (t: FileOther): ParsedFileOther => ({
  ...file_base_parser(t)
})

export const file_other_guard = (t:File): t is FileOther => (t as any).style_urls === undefined

export const file_parser = (t: File): ParsedFile => file_image_guard(t) ? file_image_parser(t) : file_other_parser(t)

export const file_guard = (t: Entity): t is File => (
  (t as any).fid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).filename !== undefined &&
  (t as any).uri !== undefined &&
  (t as any).filemime !== undefined &&
  (t as any).filesize !== undefined &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined
)

export const image_file_with_target_item_parser = (t: ImageFileWithTargetItem): ParsedImageFileWithTargetItem => ({
  alt: noop_parser<string | null>(t.alt),
  image: (t.target !== undefined ? file_image_parser(t.target) : undefined)
})

export const image_file_with_target_item_guard = (t: any): t is ImageFileWithTargetItem => (t.target_id !== undefined) && (t.alt !== undefined) && (t.title !== undefined) && (t.width !== undefined) && (t.height !== undefined) && ((t.target === undefined) || file_image_guard(t.target))

export const singular_optional_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem | null => f && f.length > 0 && image_file_with_target_item_guard(f[0]) ? image_file_with_target_item_parser(f[0]) : null

export const media_base_parser = (t: MediaBase): ParsedMediaBase => ({
  entity_type: ((_: any): "media" => "media")(t),
  id: singular_optional_integer_parser(t.mid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  uid: singular_optional_entity_reference_user_parser(t.uid),
  thumbnail: singular_optional_image_file_with_target_parser(t.thumbnail),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const file_file_with_target_item_parser = (t: FileFileWithTargetItem): ParsedFileFileWithTargetItem => ({
  description: noop_parser<string | null>(t.description),
  file: (t.target !== undefined ? file_other_parser(t.target) : undefined)
})

export const file_file_with_target_item_guard = (t: any): t is FileFileWithTargetItem => (t.target_id !== undefined) && (t.display !== undefined) && (t.description !== undefined) && ((t.target === undefined) || file_other_guard(t.target))

export const singular_required_file_file_with_target_parser = (f: FieldItemList<FileFileWithTargetItem>): ParsedFileFileWithTargetItem => file_file_with_target_item_parser(f[0])

export const media_document_parser = (t: MediaDocument): ParsedMediaDocument => ({
  ...media_base_parser(t),
  bundle: ((_: any): "document" => "document")(t.bundle),
  field_media_file: singular_required_file_file_with_target_parser(t.field_media_file)
})

export const media_document_guard = (t: Media): t is MediaDocument => media_bundle_parser(t.bundle) == "document"

export const singular_required_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem => image_file_with_target_item_parser(f[0])

export const media_image_parser = (t: MediaImage): ParsedMediaImage => ({
  ...media_base_parser(t),
  bundle: ((_: any): "image" => "image")(t.bundle),
  field_media_image: singular_required_image_file_with_target_parser(t.field_media_image),
  field_source: singular_optional_string_parser(t.field_source)
})

export const media_image_guard = (t: Media): t is MediaImage => media_bundle_parser(t.bundle) == "image"

export const video_embed_field_item_parser = (t: VideoEmbedFieldItem): ParsedVideoEmbedFieldItem => ({
  type: t.video_type,
  id: t.video_id,
  iframe_url: t.iframe_url
})

export const singular_required_video_embed_field_parser = (f: FieldItemList<VideoEmbedFieldItem>): ParsedVideoEmbedFieldItem => video_embed_field_item_parser(f[0])

export const media_video_parser = (t: MediaVideo): ParsedMediaVideo => ({
  ...media_base_parser(t),
  bundle: ((_: any): "video" => "video")(t.bundle),
  field_media_video_embed_field: singular_required_video_embed_field_parser(t.field_media_video_embed_field),
  field_source: singular_optional_string_parser(t.field_source)
})

export const media_video_guard = (t: Media): t is MediaVideo => media_bundle_parser(t.bundle) == "video"

export const media_parser = (t: Media): ParsedMedia =>
  media_document_guard(t) ?
    media_document_parser(t) :
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t)

export const media_guard = (t: Entity): t is Media => (
  (t as any).mid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).bundle !== undefined &&
  (t as any).bundle[0].target_type == "media_type" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).name !== undefined &&
  (t as any).thumbnail !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined
)

export const entity_reference_media_with_target_node_career_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeCareerFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_career_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeCareerFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_career_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeCareerFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_career_field_introduction_image_item_parser(f[0])

export const plural_link_parser =
  (f: FieldItemList<LinkItem>): List<ParsedLinkItem> =>
    List<ParsedLinkItem>(f.map(i => link_item_parser(i)))

export const metatag_item_parser = (t: MetatagItem): Metatags => t.value

export const singular_optional_metatag_parser = (f: FieldItemList<MetatagItem>): Metatags | null => f && f.length > 0 ? metatag_item_parser(f[0]) : null

export const entity_reference_paragraphs_type_item_parser = (t: EntityReferenceParagraphsTypeItem): ParsedEntityReferenceParagraphsTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_paragraphs_type_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): ParsedEntityReferenceParagraphsTypeItem => entity_reference_paragraphs_type_item_parser(f[0])

export const paragraph_bundle_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): string => f[0].target_id

export const paragraph_base_parser = (t: ParagraphBase): ParsedParagraphBase => ({
  entity_type: ((_: any): "paragraph" => "paragraph")(t),
  id: singular_optional_integer_parser(t.id),
  language: singular_optional_language_parser(t.langcode),
  status: singular_optional_boolean_parser(t.status),
  created: singular_optional_created_parser(t.created),
  parent_id: singular_optional_string_parser(t.parent_id),
  parent_type: singular_optional_string_parser(t.parent_type),
  parent_field_name: singular_optional_string_parser(t.parent_field_name),
  behavior_settings: singular_optional_string_long_parser(t.behavior_settings),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const entity_reference_media_with_target_paragraph360_building_block_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph360_building_block_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph360_building_block_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph360_building_block_field_image_item_parser(f[0])

export const entity_reference_media_with_target_paragraph360_building_block_field_preview_image_item_parser = (t: EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldPreviewImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph360_building_block_field_preview_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldPreviewImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph360_building_block_field_preview_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraph360BuildingBlockFieldPreviewImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph360_building_block_field_preview_image_item_parser(f[0])

export const paragraph360_building_block_parser = (t: Paragraph360BuildingBlock): ParsedParagraph360BuildingBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "360_building_block" => "360_building_block")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph360_building_block_field_image_parser(t.field_image),
  field_preview_image: singular_required_entity_reference_media_with_target_paragraph360_building_block_field_preview_image_parser(t.field_preview_image)
})

export const paragraph360_building_block_guard = (t: Paragraph): t is Paragraph360BuildingBlock => paragraph_bundle_parser(t.type) == "360_building_block"

export const plural_text_parser =
  (f: FieldItemList<TextItem>): List<string> =>
    List<string>(f.map(i => text_item_parser(i)))

export const plural_list_string_parser =
  (f: FieldItemList<ListStringItem>): List<string> =>
    List<string>(f.map(i => list_string_item_parser(i)))

export const text_with_summary_item_parser = (t: TextWithSummaryItem): ParsedTextWithSummaryItem => ({
  value: noop_parser<string>(t.value),
  format: noop_parser<FilterFormat | null>(t.format),
  processed: noop_parser<string | null>(t.processed),
  summary: noop_parser<string | null>(t.summary)
})

export const plural_text_with_summary_parser =
  (f: FieldItemList<TextWithSummaryItem>): List<ParsedTextWithSummaryItem> =>
    List<ParsedTextWithSummaryItem>(f.map(i => text_with_summary_item_parser(i)))

export const plural_text_long_parser =
  (f: FieldItemList<TextItem>): List<string> =>
    List<string>(f.map(i => text_item_parser(i)))

export const plural_entity_reference_node_type_parser =
  (f: FieldItemList<EntityReferenceNodeTypeItem>): List<ParsedEntityReferenceNodeTypeItem> =>
    List<ParsedEntityReferenceNodeTypeItem>(f.map(i => entity_reference_node_type_item_parser(i)))

export const paragraph_adress_block_parser = (t: ParagraphAdressBlock): ParsedParagraphAdressBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "adress_block" => "adress_block")(t.type),
  field_test1: plural_text_parser(t.field_test1),
  field_test2: plural_list_string_parser(t.field_test2),
  field_test3: plural_text_with_summary_parser(t.field_test3),
  field_test4: plural_text_long_parser(t.field_test4),
  field_test5: plural_entity_reference_node_type_parser(t.field_test5)
})

export const paragraph_adress_block_guard = (t: Paragraph): t is ParagraphAdressBlock => paragraph_bundle_parser(t.type) == "adress_block"

export const campaign_monitor_item_parser = (t: CampaignMonitorItem): string | null => noop_parser<string | null>(t.value)

export const singular_required_campaign_monitor_parser = (f: FieldItemList<CampaignMonitorItem>): string | null => campaign_monitor_item_parser(f[0])

export const paragraph_campaign_manager_parser = (t: ParagraphCampaignManager): ParsedParagraphCampaignManager => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "campaign_manager" => "campaign_manager")(t.type),
  field_body: singular_optional_text_long_parser(t.field_body),
  field_collapsed: singular_optional_boolean_parser(t.field_collapsed),
  field_form: singular_required_campaign_monitor_parser(t.field_form),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_campaign_manager_guard = (t: Paragraph): t is ParagraphCampaignManager => paragraph_bundle_parser(t.type) == "campaign_manager"

export const entity_reference_taxonomy_term_with_target_paragraph_category_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetParagraphCategoryFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_paragraph_category_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetParagraphCategoryFieldCategoryItem => (t.target_id !== undefined)

export const singular_required_entity_reference_taxonomy_term_with_target_paragraph_category_field_category_parser = (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetParagraphCategoryFieldCategoryItem>): ParsedTaxonomyTermRelatedContent | undefined => entity_reference_taxonomy_term_with_target_paragraph_category_field_category_item_parser(f[0])

export const paragraph_category_parser = (t: ParagraphCategory): ParsedParagraphCategory => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "category" => "category")(t.type),
  field_category: singular_required_entity_reference_taxonomy_term_with_target_paragraph_category_field_category_parser(t.field_category),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_category_guard = (t: Paragraph): t is ParagraphCategory => paragraph_bundle_parser(t.type) == "category"

export const entity_reference_media_with_target_paragraph_contact_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphContactFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_contact_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphContactFieldImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_contact_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphContactFieldImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_contact_field_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_contact_field_image_item_parser(f[0]) : null

export const singular_required_string_long_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const paragraph_contact_parser = (t: ParagraphContact): ParsedParagraphContact => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "contact" => "contact")(t.type),
  field_e_mail: plural_email_parser(t.field_e_mail),
  field_image: singular_optional_entity_reference_media_with_target_paragraph_contact_field_image_parser(t.field_image),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_name: singular_required_string_parser(t.field_name),
  field_phone: plural_telephone_parser(t.field_phone),
  field_subtitle: singular_required_string_parser(t.field_subtitle),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_contact_guard = (t: Paragraph): t is ParagraphContact => paragraph_bundle_parser(t.type) == "contact"

export const singular_required_list_string_parser = (f: FieldItemList<ListStringItem>): string => list_string_item_parser(f[0])

export const entity_reference_media_with_target_paragraph_cta_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphCtaFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_cta_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphCtaFieldImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_cta_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphCtaFieldImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_cta_field_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_cta_field_image_item_parser(f[0]) : null

export const paragraph_cta_parser = (t: ParagraphCta): ParsedParagraphCta => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "cta" => "cta")(t.type),
  field_cta_background: singular_required_list_string_parser(t.field_cta_background),
  field_display_option: singular_optional_list_string_parser(t.field_display_option),
  field_image: singular_optional_entity_reference_media_with_target_paragraph_cta_field_image_parser(t.field_image),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_link_type: singular_optional_boolean_parser(t.field_link_type),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_cta_guard = (t: Paragraph): t is ParagraphCta => paragraph_bundle_parser(t.type) == "cta"

export const entity_reference_media_with_target_paragraph_cta_with_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphCtaWithImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_cta_with_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphCtaWithImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_cta_with_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphCtaWithImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_cta_with_image_field_image_item_parser(f[0])

export const paragraph_cta_with_image_parser = (t: ParagraphCtaWithImage): ParsedParagraphCtaWithImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "cta_with_image" => "cta_with_image")(t.type),
  field_display_option: singular_optional_list_string_parser(t.field_display_option),
  field_image: singular_required_entity_reference_media_with_target_paragraph_cta_with_image_field_image_parser(t.field_image),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_link_type: singular_optional_boolean_parser(t.field_link_type),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_cta_with_image_guard = (t: Paragraph): t is ParagraphCtaWithImage => paragraph_bundle_parser(t.type) == "cta_with_image"

export const entity_reference_media_with_target_paragraph_development_block_field_images_item_parser = (t: EntityReferenceMediaWithTargetParagraphDevelopmentBlockFieldImagesItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_development_block_field_images_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDevelopmentBlockFieldImagesItem => (t.target_id !== undefined)

export const plural_entity_reference_media_with_target_paragraph_development_block_field_images_parser =
  (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDevelopmentBlockFieldImagesItem>): List<ParsedMediaImage> =>
    List<ParsedMediaImage>(f.filter(i => entity_reference_media_with_target_paragraph_development_block_field_images_item_guard(i)).map(i => entity_reference_media_with_target_paragraph_development_block_field_images_item_parser(i)).filter(i => i !== undefined))

export const paragraph_development_block_parser = (t: ParagraphDevelopmentBlock): ParsedParagraphDevelopmentBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "development_block" => "development_block")(t.type),
  field_images: plural_entity_reference_media_with_target_paragraph_development_block_field_images_parser(t.field_images),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_development_block_guard = (t: Paragraph): t is ParagraphDevelopmentBlock => paragraph_bundle_parser(t.type) == "development_block"

export const singular_required_text_long_parser = (f: FieldItemList<TextItem>): string => text_item_parser(f[0])

export const entity_reference_media_with_target_paragraph_double_text_with_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_double_text_with_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_double_text_with_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_double_text_with_image_field_image_item_parser(f[0])

export const entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldSecondaryImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldSecondaryImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDoubleTextWithImageFieldSecondaryImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_item_parser(f[0]) : null

export const paragraph_double_text_with_image_parser = (t: ParagraphDoubleTextWithImage): ParsedParagraphDoubleTextWithImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "double_text_with_image" => "double_text_with_image")(t.type),
  field_body: singular_required_text_long_parser(t.field_body),
  field_featured_content_direction: singular_required_list_string_parser(t.field_featured_content_direction),
  field_image: singular_required_entity_reference_media_with_target_paragraph_double_text_with_image_field_image_parser(t.field_image),
  field_link: singular_optional_link_parser(t.field_link),
  field_secondary_content: singular_optional_text_long_parser(t.field_secondary_content),
  field_secondary_image: singular_optional_entity_reference_media_with_target_paragraph_double_text_with_image_field_secondary_image_parser(t.field_secondary_image),
  field_secondary_link: singular_optional_link_parser(t.field_secondary_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_double_text_with_image_guard = (t: Paragraph): t is ParagraphDoubleTextWithImage => paragraph_bundle_parser(t.type) == "double_text_with_image"

export const entity_reference_media_with_target_paragraph_download_list_field_download_item_parser = (t: EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem): ParsedMediaDocument | ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument | MediaImage): ParsedMediaDocument | ParsedMediaImage =>
  media_document_guard(t) ?
    media_document_parser(t) :
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_download_list_field_download_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_download_list_field_download_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem>): ParsedMediaDocument | ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_download_list_field_download_item_parser(f[0])

export const paragraph_download_list_parser = (t: ParagraphDownloadList): ParsedParagraphDownloadList => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "download_list" => "download_list")(t.type),
  field_archive: singular_optional_boolean_parser(t.field_archive),
  field_download: singular_required_entity_reference_media_with_target_paragraph_download_list_field_download_parser(t.field_download),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_download_list_guard = (t: Paragraph): t is ParagraphDownloadList => paragraph_bundle_parser(t.type) == "download_list"

export const entity_reference_media_with_target_paragraph_download_list_nested_field_download_item_parser = (t: EntityReferenceMediaWithTargetParagraphDownloadListNestedFieldDownloadItem): ParsedMediaDocument | ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument | MediaImage): ParsedMediaDocument | ParsedMediaImage =>
  media_document_guard(t) ?
    media_document_parser(t) :
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_download_list_nested_field_download_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDownloadListNestedFieldDownloadItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_download_list_nested_field_download_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDownloadListNestedFieldDownloadItem>): ParsedMediaDocument | ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_download_list_nested_field_download_item_parser(f[0])

export const paragraph_download_list_nested_parser = (t: ParagraphDownloadListNested): ParsedParagraphDownloadListNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "download_list_nested" => "download_list_nested")(t.type),
  field_download: singular_required_entity_reference_media_with_target_paragraph_download_list_nested_field_download_parser(t.field_download),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_download_list_nested_guard = (t: Paragraph): t is ParagraphDownloadListNested => paragraph_bundle_parser(t.type) == "download_list_nested"

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem): ParsedParagraphDownloadList | undefined | undefined => (t.target !== undefined ? ((t: ParagraphDownloadList): ParsedParagraphDownloadList =>
    paragraph_download_list_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem>): List<ParsedParagraphDownloadList> =>
    List<ParsedParagraphDownloadList>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_parser(i)).filter(i => i !== undefined))

export const paragraph_downloads_parser = (t: ParagraphDownloads): ParsedParagraphDownloads => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "downloads" => "downloads")(t.type),
  field_download_list: plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_parser(t.field_download_list),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_downloads_guard = (t: Paragraph): t is ParagraphDownloads => paragraph_bundle_parser(t.type) == "downloads"

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsNestedFieldDownloadListNestedItem): ParsedParagraphDownloadListNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphDownloadListNested): ParsedParagraphDownloadListNested =>
    paragraph_download_list_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsNestedFieldDownloadListNestedItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsNestedFieldDownloadListNestedItem>): List<ParsedParagraphDownloadListNested> =>
    List<ParsedParagraphDownloadListNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_item_parser(i)).filter(i => i !== undefined))

export const paragraph_downloads_nested_parser = (t: ParagraphDownloadsNested): ParsedParagraphDownloadsNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "downloads_nested" => "downloads_nested")(t.type),
  field_download_list_nested: plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_nested_field_download_list_nested_parser(t.field_download_list_nested),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_downloads_nested_guard = (t: Paragraph): t is ParagraphDownloadsNested => paragraph_bundle_parser(t.type) == "downloads_nested"

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlockFieldContentBlockItem): ParsedParagraphQuoteNested | ParsedParagraphOffice | ParsedParagraphMediaNested | ParsedParagraphDownloadsNested | ParsedParagraphTextNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphQuoteNested | ParagraphOffice | ParagraphMediaNested | ParagraphDownloadsNested | ParagraphTextNested): ParsedParagraphQuoteNested | ParsedParagraphOffice | ParsedParagraphMediaNested | ParsedParagraphDownloadsNested | ParsedParagraphTextNested =>
  paragraph_quote_nested_guard(t) ?
    paragraph_quote_nested_parser(t) :
  paragraph_office_guard(t) ?
    paragraph_office_parser(t) :
  paragraph_media_nested_guard(t) ?
    paragraph_media_nested_parser(t) :
  paragraph_downloads_nested_guard(t) ?
    paragraph_downloads_nested_parser(t) :
    paragraph_text_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlockFieldContentBlockItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlockFieldContentBlockItem>): List<ParsedParagraphQuoteNested | ParsedParagraphOffice | ParsedParagraphMediaNested | ParsedParagraphDownloadsNested | ParsedParagraphTextNested> =>
    List<ParsedParagraphQuoteNested | ParsedParagraphOffice | ParsedParagraphMediaNested | ParsedParagraphDownloadsNested | ParsedParagraphTextNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_parser = (t: EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem => (t.target_id !== undefined)

export const plural_entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_parser =
  (f: FieldItemList<EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem>): List<ParsedMediaDocument> =>
    List<ParsedMediaDocument>(f.filter(i => entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_guard(i)).map(i => entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_parser(i)).filter(i => i !== undefined))

export const paragraph_expandable_content_block_parser = (t: ParagraphExpandableContentBlock): ParsedParagraphExpandableContentBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expandable_content_block" => "expandable_content_block")(t.type),
  field_body: singular_optional_text_long_parser(t.field_body),
  field_content_block: plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_block_field_content_block_parser(t.field_content_block),
  field_downloads: plural_entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_parser(t.field_downloads),
  field_link_list: plural_link_parser(t.field_link_list),
  field_subtitle: singular_optional_string_parser(t.field_subtitle),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_expandable_content_block_guard = (t: Paragraph): t is ParagraphExpandableContentBlock => paragraph_bundle_parser(t.type) == "expandable_content_block"

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem): ParsedParagraphExpandableContentBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphExpandableContentBlock): ParsedParagraphExpandableContentBlock =>
    paragraph_expandable_content_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem>): List<ParsedParagraphExpandableContentBlock> =>
    List<ParsedParagraphExpandableContentBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_expandable_content_blocks_parser = (t: ParagraphExpandableContentBlocks): ParsedParagraphExpandableContentBlocks => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expandable_content_blocks" => "expandable_content_blocks")(t.type),
  field_expandable_content_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_parser(t.field_expandable_content_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_expandable_content_blocks_guard = (t: Paragraph): t is ParagraphExpandableContentBlocks => paragraph_bundle_parser(t.type) == "expandable_content_blocks"

export const entity_reference_revisions_paragraph_with_target_paragraph_extra_navigational_element_field_extra_elements_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphExtraNavigationalElementFieldExtraElementsItem): ParsedParagraphCategory | ParsedParagraphGridBlocksImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCategory | ParagraphGridBlocksImage): ParsedParagraphCategory | ParsedParagraphGridBlocksImage =>
  paragraph_category_guard(t) ?
    paragraph_category_parser(t) :
    paragraph_grid_blocks_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_extra_navigational_element_field_extra_elements_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphExtraNavigationalElementFieldExtraElementsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const singular_required_entity_reference_revisions_paragraph_with_target_paragraph_extra_navigational_element_field_extra_elements_parser = (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphExtraNavigationalElementFieldExtraElementsItem>): ParsedParagraphCategory | ParsedParagraphGridBlocksImage | undefined => entity_reference_revisions_paragraph_with_target_paragraph_extra_navigational_element_field_extra_elements_item_parser(f[0])

export const paragraph_extra_navigational_element_parser = (t: ParagraphExtraNavigationalElement): ParsedParagraphExtraNavigationalElement => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "extra_navigational_element" => "extra_navigational_element")(t.type),
  field_extra_elements: singular_required_entity_reference_revisions_paragraph_with_target_paragraph_extra_navigational_element_field_extra_elements_parser(t.field_extra_elements)
})

export const paragraph_extra_navigational_element_guard = (t: Paragraph): t is ParagraphExtraNavigationalElement => paragraph_bundle_parser(t.type) == "extra_navigational_element"

export const entity_reference_node_with_target_paragraph_featured_content_field_featured_content_item_parser = (t: EntityReferenceNodeWithTargetParagraphFeaturedContentFieldFeaturedContentItem): ParsedNodePage | undefined | undefined => (t.target !== undefined ? ((t: NodePage): ParsedNodePage =>
    node_page_parser(t))(t.target) : undefined)

export const entity_reference_node_with_target_paragraph_featured_content_field_featured_content_item_guard = (t: any): t is EntityReferenceNodeWithTargetParagraphFeaturedContentFieldFeaturedContentItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_node_with_target_paragraph_featured_content_field_featured_content_parser = (f: FieldItemList<EntityReferenceNodeWithTargetParagraphFeaturedContentFieldFeaturedContentItem>): ParsedNodePage | undefined | null => f && f.length > 0 && entity_reference_node_with_target_paragraph_featured_content_field_featured_content_item_guard(f[0]) ? entity_reference_node_with_target_paragraph_featured_content_field_featured_content_item_parser(f[0]) : null

export const paragraph_featured_content_parser = (t: ParagraphFeaturedContent): ParsedParagraphFeaturedContent => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "featured_content" => "featured_content")(t.type),
  field_featured_content: singular_optional_entity_reference_node_with_target_paragraph_featured_content_field_featured_content_parser(t.field_featured_content),
  field_featured_content_direction: singular_optional_list_string_parser(t.field_featured_content_direction)
})

export const paragraph_featured_content_guard = (t: Paragraph): t is ParagraphFeaturedContent => paragraph_bundle_parser(t.type) == "featured_content"

export const form_list_item_parser = (t: FormListItem): string | null => noop_parser<string | null>(t.value)

export const singular_required_form_list_parser = (f: FieldItemList<FormListItem>): string | null => form_list_item_parser(f[0])

export const paragraph_form_parser = (t: ParagraphForm): ParsedParagraphForm => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "form" => "form")(t.type),
  field_form_list: singular_required_form_list_parser(t.field_form_list),
  field_form_type: singular_required_list_string_parser(t.field_form_type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_form_guard = (t: Paragraph): t is ParagraphForm => paragraph_bundle_parser(t.type) == "form"

export const entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_grid_block_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_parser(f[0])

export const paragraph_grid_block_image_parser = (t: ParagraphGridBlockImage): ParsedParagraphGridBlockImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_block_image" => "grid_block_image")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_grid_block_image_field_image_parser(t.field_image),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_label: singular_optional_string_parser(t.field_label),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_block_image_guard = (t: Paragraph): t is ParagraphGridBlockImage => paragraph_bundle_parser(t.type) == "grid_block_image"

export const paragraph_grid_block_plain_parser = (t: ParagraphGridBlockPlain): ParsedParagraphGridBlockPlain => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_block_plain" => "grid_block_plain")(t.type),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_label: singular_optional_string_parser(t.field_label),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_grid_block_plain_guard = (t: Paragraph): t is ParagraphGridBlockPlain => paragraph_bundle_parser(t.type) == "grid_block_plain"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem): ParsedParagraphGridBlockImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridBlockImage): ParsedParagraphGridBlockImage =>
    paragraph_grid_block_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem>): List<ParsedParagraphGridBlockImage> =>
    List<ParsedParagraphGridBlockImage>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_blocks_image_parser = (t: ParagraphGridBlocksImage): ParsedParagraphGridBlocksImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_blocks_image" => "grid_blocks_image")(t.type),
  field_background: singular_required_list_string_parser(t.field_background),
  field_grid_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_parser(t.field_grid_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_blocks_image_guard = (t: Paragraph): t is ParagraphGridBlocksImage => paragraph_bundle_parser(t.type) == "grid_blocks_image"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem): ParsedParagraphGridBlockPlain | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridBlockPlain): ParsedParagraphGridBlockPlain =>
    paragraph_grid_block_plain_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem>): List<ParsedParagraphGridBlockPlain> =>
    List<ParsedParagraphGridBlockPlain>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_blocks_plain_parser = (t: ParagraphGridBlocksPlain): ParsedParagraphGridBlocksPlain => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_blocks_plain" => "grid_blocks_plain")(t.type),
  field_background: singular_required_list_string_parser(t.field_background),
  field_grid_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_parser(t.field_grid_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_blocks_plain_guard = (t: Paragraph): t is ParagraphGridBlocksPlain => paragraph_bundle_parser(t.type) == "grid_blocks_plain"

export const paragraph_hubspot_form_parser = (t: ParagraphHubspotForm): ParsedParagraphHubspotForm => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "hubspot_form" => "hubspot_form")(t.type),
  field_form_id: singular_required_string_parser(t.field_form_id),
  field_portal_id: singular_required_string_parser(t.field_portal_id)
})

export const paragraph_hubspot_form_guard = (t: Paragraph): t is ParagraphHubspotForm => paragraph_bundle_parser(t.type) == "hubspot_form"

export const paragraph_icon_parser = (t: ParagraphIcon): ParsedParagraphIcon => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "icon" => "icon")(t.type),
  field_icon: singular_required_list_string_parser(t.field_icon)
})

export const paragraph_icon_guard = (t: Paragraph): t is ParagraphIcon => paragraph_bundle_parser(t.type) == "icon"

export const paragraph_icon_with_text_parser = (t: ParagraphIconWithText): ParsedParagraphIconWithText => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "icon_with_text" => "icon_with_text")(t.type),
  field_icon: singular_required_list_string_parser(t.field_icon),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_icon_with_text_guard = (t: Paragraph): t is ParagraphIconWithText => paragraph_bundle_parser(t.type) == "icon_with_text"

export const singular_required_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem => link_item_parser(f[0])

export const paragraph_iframe_parser = (t: ParagraphIframe): ParsedParagraphIframe => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "iframe" => "iframe")(t.type),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_iframe_guard = (t: Paragraph): t is ParagraphIframe => paragraph_bundle_parser(t.type) == "iframe"

export const paragraph_iframe_code_parser = (t: ParagraphIframeCode): ParsedParagraphIframeCode => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "iframe_code" => "iframe_code")(t.type),
  field_iframe_code: singular_required_string_long_parser(t.field_iframe_code)
})

export const paragraph_iframe_code_guard = (t: Paragraph): t is ParagraphIframeCode => paragraph_bundle_parser(t.type) == "iframe_code"

export const entity_reference_media_with_target_paragraph_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_image_field_image_item_parser(f[0])

export const paragraph_image_parser = (t: ParagraphImage): ParsedParagraphImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "image" => "image")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_image_field_image_parser(t.field_image),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption)
})

export const paragraph_image_guard = (t: Paragraph): t is ParagraphImage => paragraph_bundle_parser(t.type) == "image"

export const entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem): ParsedParagraphImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphImage): ParsedParagraphImage =>
    paragraph_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem>): List<ParsedParagraphImage> =>
    List<ParsedParagraphImage>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_parser(i)).filter(i => i !== undefined))

export const paragraph_image_gallery_parser = (t: ParagraphImageGallery): ParsedParagraphImageGallery => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "image_gallery" => "image_gallery")(t.type),
  field_image_gallery: plural_entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_parser(t.field_image_gallery),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_image_gallery_guard = (t: Paragraph): t is ParagraphImageGallery => paragraph_bundle_parser(t.type) == "image_gallery"

export const paragraph_job_alert_parser = (t: ParagraphJobAlert): ParsedParagraphJobAlert => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "job_alert" => "job_alert")(t.type)
})

export const paragraph_job_alert_guard = (t: Paragraph): t is ParagraphJobAlert => paragraph_bundle_parser(t.type) == "job_alert"

export const paragraph_link_list_item_parser = (t: ParagraphLinkListItem): ParsedParagraphLinkListItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "link_list_item" => "link_list_item")(t.type),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_url: singular_required_link_parser(t.field_url)
})

export const paragraph_link_list_item_guard = (t: Paragraph): t is ParagraphLinkListItem => paragraph_bundle_parser(t.type) == "link_list_item"

export const entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem): ParsedParagraphLinkListItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphLinkListItem): ParsedParagraphLinkListItem =>
    paragraph_link_list_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem>): List<ParsedParagraphLinkListItem> =>
    List<ParsedParagraphLinkListItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_parser(i)).filter(i => i !== undefined))

export const paragraph_links_list_parser = (t: ParagraphLinksList): ParsedParagraphLinksList => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "links_list" => "links_list")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_links_list: plural_entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_parser(t.field_links_list),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_links_list_guard = (t: Paragraph): t is ParagraphLinksList => paragraph_bundle_parser(t.type) == "links_list"

export const paragraph_magazine_embed_parser = (t: ParagraphMagazineEmbed): ParsedParagraphMagazineEmbed => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "magazine_embed" => "magazine_embed")(t.type),
  field_magazine_embed_id: singular_required_string_parser(t.field_magazine_embed_id)
})

export const paragraph_magazine_embed_guard = (t: Paragraph): t is ParagraphMagazineEmbed => paragraph_bundle_parser(t.type) == "magazine_embed"

export const entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphMediaFieldMediaItemItem): ParsedParagraphMediaItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphMediaItem): ParsedParagraphMediaItem =>
    paragraph_media_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphMediaFieldMediaItemItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphMediaFieldMediaItemItem>): List<ParsedParagraphMediaItem> =>
    List<ParsedParagraphMediaItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_media_parser = (t: ParagraphMedia): ParsedParagraphMedia => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media" => "media")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_media_item: plural_entity_reference_revisions_paragraph_with_target_paragraph_media_field_media_item_parser(t.field_media_item),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_media_guard = (t: Paragraph): t is ParagraphMedia => paragraph_bundle_parser(t.type) == "media"

export const entity_reference_media_with_target_paragraph_media_item_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_item_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_item_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_item_field_media_item_parser(f[0])

export const paragraph_media_item_parser = (t: ParagraphMediaItem): ParsedParagraphMediaItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_item" => "media_item")(t.type),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption),
  field_image_option: singular_optional_list_string_parser(t.field_image_option),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_item_field_media_parser(t.field_media)
})

export const paragraph_media_item_guard = (t: Paragraph): t is ParagraphMediaItem => paragraph_bundle_parser(t.type) == "media_item"

export const entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_item_nested_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_parser(f[0])

export const paragraph_media_item_nested_parser = (t: ParagraphMediaItemNested): ParsedParagraphMediaItemNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_item_nested" => "media_item_nested")(t.type),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_item_nested_field_media_parser(t.field_media)
})

export const paragraph_media_item_nested_guard = (t: Paragraph): t is ParagraphMediaItemNested => paragraph_bundle_parser(t.type) == "media_item_nested"

export const entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem): ParsedParagraphMediaItemNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphMediaItemNested): ParsedParagraphMediaItemNested =>
    paragraph_media_item_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem>): List<ParsedParagraphMediaItemNested> =>
    List<ParsedParagraphMediaItemNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_media_nested_parser = (t: ParagraphMediaNested): ParsedParagraphMediaNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_nested" => "media_nested")(t.type),
  field_media_item: plural_entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_parser(t.field_media_item)
})

export const paragraph_media_nested_guard = (t: Paragraph): t is ParagraphMediaNested => paragraph_bundle_parser(t.type) == "media_nested"

export const plural_string_parser =
  (f: FieldItemList<StringItem>): List<string> =>
    List<string>(f.map(i => string_item_parser(i)))

export const paragraph_office_parser = (t: ParagraphOffice): ParsedParagraphOffice => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "office" => "office")(t.type),
  field_address: singular_optional_string_parser(t.field_address),
  field_body: singular_optional_text_long_parser(t.field_body),
  field_country: singular_optional_string_parser(t.field_country),
  field_email: plural_string_parser(t.field_email),
  field_fax: plural_string_parser(t.field_fax),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_main_title: singular_optional_string_parser(t.field_main_title),
  field_map_link: singular_optional_link_parser(t.field_map_link),
  field_postal_address: singular_optional_string_parser(t.field_postal_address),
  field_postal_country: singular_optional_string_parser(t.field_postal_country),
  field_postaladdress: singular_optional_text_long_parser(t.field_postaladdress),
  field_subtitle: singular_optional_string_parser(t.field_subtitle),
  field_telephone: plural_string_parser(t.field_telephone),
  field_title: singular_optional_string_parser(t.field_title),
  field_website: singular_optional_link_parser(t.field_website)
})

export const paragraph_office_guard = (t: Paragraph): t is ParagraphOffice => paragraph_bundle_parser(t.type) == "office"

export const entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_item_parser = (t: EntityReferenceTaxonomyTermWithTargetParagraphPressFieldContactPersonItem): ParsedTaxonomyTermPressContact | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermPressContact): ParsedTaxonomyTermPressContact =>
    taxonomy_term_press_contact_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetParagraphPressFieldContactPersonItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_parser = (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetParagraphPressFieldContactPersonItem>): ParsedTaxonomyTermPressContact | undefined | null => f && f.length > 0 && entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_item_guard(f[0]) ? entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_item_parser(f[0]) : null

export const paragraph_press_parser = (t: ParagraphPress): ParsedParagraphPress => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "press" => "press")(t.type),
  field_contact_person: singular_optional_entity_reference_taxonomy_term_with_target_paragraph_press_field_contact_person_parser(t.field_contact_person)
})

export const paragraph_press_guard = (t: Paragraph): t is ParagraphPress => paragraph_bundle_parser(t.type) == "press"

export const paragraph_press_releases_parser = (t: ParagraphPressReleases): ParsedParagraphPressReleases => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "press_releases" => "press_releases")(t.type),
  field_button: singular_optional_link_parser(t.field_button),
  field_item_limit: singular_optional_integer_parser(t.field_item_limit),
  field_show_year_filter: singular_optional_boolean_parser(t.field_show_year_filter)
})

export const paragraph_press_releases_guard = (t: Paragraph): t is ParagraphPressReleases => paragraph_bundle_parser(t.type) == "press_releases"

export const paragraph_quote_parser = (t: ParagraphQuote): ParsedParagraphQuote => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote" => "quote")(t.type),
  field_author_name: singular_optional_string_parser(t.field_author_name),
  field_link: singular_optional_link_parser(t.field_link),
  field_links: plural_link_parser(t.field_links),
  field_text: singular_required_string_long_parser(t.field_text)
})

export const paragraph_quote_guard = (t: Paragraph): t is ParagraphQuote => paragraph_bundle_parser(t.type) == "quote"

export const paragraph_quote_nested_parser = (t: ParagraphQuoteNested): ParsedParagraphQuoteNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote_nested" => "quote_nested")(t.type),
  field_author_name: singular_optional_string_parser(t.field_author_name),
  field_text: singular_required_string_long_parser(t.field_text)
})

export const paragraph_quote_nested_guard = (t: Paragraph): t is ParagraphQuoteNested => paragraph_bundle_parser(t.type) == "quote_nested"

export const entity_reference_media_with_target_paragraph_quote_with_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphQuoteWithImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_quote_with_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphQuoteWithImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_quote_with_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphQuoteWithImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_quote_with_image_field_image_item_parser(f[0])

export const paragraph_quote_with_image_parser = (t: ParagraphQuoteWithImage): ParsedParagraphQuoteWithImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote_with_image" => "quote_with_image")(t.type),
  field_author_name: singular_optional_string_parser(t.field_author_name),
  field_image: singular_required_entity_reference_media_with_target_paragraph_quote_with_image_field_image_parser(t.field_image),
  field_link: singular_optional_link_parser(t.field_link),
  field_text: singular_required_string_long_parser(t.field_text)
})

export const paragraph_quote_with_image_guard = (t: Paragraph): t is ParagraphQuoteWithImage => paragraph_bundle_parser(t.type) == "quote_with_image"

export const paragraph_related_content_load_more_parser = (t: ParagraphRelatedContentLoadMore): ParsedParagraphRelatedContentLoadMore => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "related_content_load_more" => "related_content_load_more")(t.type),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_related_content_load_more_guard = (t: Paragraph): t is ParagraphRelatedContentLoadMore => paragraph_bundle_parser(t.type) == "related_content_load_more"

export const paragraph_stories_grid_parser = (t: ParagraphStoriesGrid): ParsedParagraphStoriesGrid => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "stories_grid" => "stories_grid")(t.type),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_stories_grid_guard = (t: Paragraph): t is ParagraphStoriesGrid => paragraph_bundle_parser(t.type) == "stories_grid"

export const paragraph_text_parser = (t: ParagraphText): ParsedParagraphText => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text" => "text")(t.type),
  field_background: singular_optional_list_string_parser(t.field_background),
  field_body: singular_required_text_long_parser(t.field_body),
  field_link_type: singular_optional_boolean_parser(t.field_link_type),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_guard = (t: Paragraph): t is ParagraphText => paragraph_bundle_parser(t.type) == "text"

export const paragraph_text_nested_parser = (t: ParagraphTextNested): ParsedParagraphTextNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_nested" => "text_nested")(t.type),
  field_body: singular_required_text_long_parser(t.field_body)
})

export const paragraph_text_nested_guard = (t: Paragraph): t is ParagraphTextNested => paragraph_bundle_parser(t.type) == "text_nested"

export const entity_reference_media_with_target_paragraph_text_with_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_text_with_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_text_with_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_text_with_image_field_image_item_parser(f[0])

export const paragraph_text_with_image_parser = (t: ParagraphTextWithImage): ParsedParagraphTextWithImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_with_image" => "text_with_image")(t.type),
  field_background: singular_required_list_string_parser(t.field_background),
  field_body: singular_required_text_long_parser(t.field_body),
  field_featured_content_direction: singular_required_list_string_parser(t.field_featured_content_direction),
  field_image: singular_required_entity_reference_media_with_target_paragraph_text_with_image_field_image_parser(t.field_image),
  field_label: singular_optional_string_parser(t.field_label),
  field_link_type: singular_optional_boolean_parser(t.field_link_type),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_with_image_guard = (t: Paragraph): t is ParagraphTextWithImage => paragraph_bundle_parser(t.type) == "text_with_image"

export const entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem): ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphQuoteNested | ParagraphMediaNested | ParagraphTextNested): ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested =>
  paragraph_quote_nested_guard(t) ?
    paragraph_quote_nested_parser(t) :
  paragraph_media_nested_guard(t) ?
    paragraph_media_nested_parser(t) :
    paragraph_text_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem>): List<ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested> =>
    List<ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_parser(i)).filter(i => i !== undefined))

export const paragraph_text_with_read_more_parser = (t: ParagraphTextWithReadMore): ParsedParagraphTextWithReadMore => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_with_read_more" => "text_with_read_more")(t.type),
  field_body: singular_required_text_long_parser(t.field_body),
  field_read_more: plural_entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_parser(t.field_read_more),
  field_read_more_close_label: singular_required_string_parser(t.field_read_more_close_label),
  field_read_more_open_label: singular_required_string_parser(t.field_read_more_open_label),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_with_read_more_guard = (t: Paragraph): t is ParagraphTextWithReadMore => paragraph_bundle_parser(t.type) == "text_with_read_more"

export const entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem): ParsedParagraphTimelineItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphTimelineItem): ParsedParagraphTimelineItem =>
    paragraph_timeline_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem>): List<ParsedParagraphTimelineItem> =>
    List<ParsedParagraphTimelineItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_timeline_parser = (t: ParagraphTimeline): ParsedParagraphTimeline => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "timeline" => "timeline")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_parser(t.field_items),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_timeline_guard = (t: Paragraph): t is ParagraphTimeline => paragraph_bundle_parser(t.type) == "timeline"

export const entity_reference_media_with_target_paragraph_timeline_item_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_timeline_item_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_timeline_item_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_timeline_item_field_media_item_parser(f[0])

export const paragraph_timeline_item_parser = (t: ParagraphTimelineItem): ParsedParagraphTimelineItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "timeline_item" => "timeline_item")(t.type),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_media: singular_required_entity_reference_media_with_target_paragraph_timeline_item_field_media_parser(t.field_media),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_timeline_item_guard = (t: Paragraph): t is ParagraphTimelineItem => paragraph_bundle_parser(t.type) == "timeline_item"

export const paragraph_updates_parser = (t: ParagraphUpdates): ParsedParagraphUpdates => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "updates" => "updates")(t.type),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_updates_guard = (t: Paragraph): t is ParagraphUpdates => paragraph_bundle_parser(t.type) == "updates"

export const paragraph_parser = (t: Paragraph): ParsedParagraph =>
  paragraph360_building_block_guard(t) ?
    paragraph360_building_block_parser(t) :
  paragraph_adress_block_guard(t) ?
    paragraph_adress_block_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_category_guard(t) ?
    paragraph_category_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_cta_with_image_guard(t) ?
    paragraph_cta_with_image_parser(t) :
  paragraph_development_block_guard(t) ?
    paragraph_development_block_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_download_list_guard(t) ?
    paragraph_download_list_parser(t) :
  paragraph_download_list_nested_guard(t) ?
    paragraph_download_list_nested_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_downloads_nested_guard(t) ?
    paragraph_downloads_nested_parser(t) :
  paragraph_expandable_content_block_guard(t) ?
    paragraph_expandable_content_block_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_block_image_guard(t) ?
    paragraph_grid_block_image_parser(t) :
  paragraph_grid_block_plain_guard(t) ?
    paragraph_grid_block_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_hubspot_form_guard(t) ?
    paragraph_hubspot_form_parser(t) :
  paragraph_icon_guard(t) ?
    paragraph_icon_parser(t) :
  paragraph_icon_with_text_guard(t) ?
    paragraph_icon_with_text_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_guard(t) ?
    paragraph_image_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_job_alert_guard(t) ?
    paragraph_job_alert_parser(t) :
  paragraph_link_list_item_guard(t) ?
    paragraph_link_list_item_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_media_item_guard(t) ?
    paragraph_media_item_parser(t) :
  paragraph_media_item_nested_guard(t) ?
    paragraph_media_item_nested_parser(t) :
  paragraph_media_nested_guard(t) ?
    paragraph_media_nested_parser(t) :
  paragraph_office_guard(t) ?
    paragraph_office_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_press_releases_guard(t) ?
    paragraph_press_releases_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_nested_guard(t) ?
    paragraph_quote_nested_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_related_content_load_more_guard(t) ?
    paragraph_related_content_load_more_parser(t) :
  paragraph_stories_grid_guard(t) ?
    paragraph_stories_grid_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_text_nested_guard(t) ?
    paragraph_text_nested_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_text_with_read_more_guard(t) ?
    paragraph_text_with_read_more_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
  paragraph_timeline_item_guard(t) ?
    paragraph_timeline_item_parser(t) :
    paragraph_updates_parser(t)

export const paragraph_guard = (t: Entity): t is Paragraph => (
  (t as any).id !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "paragraphs_type" &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).parent_id !== undefined &&
  (t as any).parent_type !== undefined &&
  (t as any).parent_field_name !== undefined &&
  (t as any).behavior_settings !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined
)

export const entity_reference_revisions_paragraph_with_target_node_career_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeCareerFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_career_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeCareerFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_career_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeCareerFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_career_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_career_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_career_parser = (t: NodeCareer): ParsedNodeCareer => ({
  ...node_base_parser(t),
  bundle: ((_: any): "career" => "career")(t.type),
  field_button: singular_optional_link_parser(t.field_button),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_career_field_category_parser(t.field_category),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_career_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_career_field_page_content_parser(t.field_page_content)
})

export const node_career_guard = (t: Node): t is NodeCareer => node_bundle_parser(t.type) == "career"

export const entity_reference_taxonomy_term_with_target_node_case_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodeCaseFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_case_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodeCaseFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_case_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodeCaseFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_case_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_case_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_case_field_icon_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldIconItem): ParsedParagraphIcon | undefined | undefined => (t.target !== undefined ? ((t: ParagraphIcon): ParsedParagraphIcon =>
    paragraph_icon_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_case_field_icon_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldIconItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const singular_required_entity_reference_revisions_paragraph_with_target_node_case_field_icon_parser = (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldIconItem>): ParsedParagraphIcon | undefined => entity_reference_revisions_paragraph_with_target_node_case_field_icon_item_parser(f[0])

export const entity_reference_media_with_target_node_case_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeCaseFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_case_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeCaseFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_case_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeCaseFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_case_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_case_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldPageContentItem): ParsedParagraphText | ParsedParagraphCampaignManager | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlockPlain | ParsedParagraphGridBlocksImage | ParsedParagraph360BuildingBlock | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCampaignManager | ParagraphCta | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlockPlain | ParagraphGridBlocksImage | Paragraph360BuildingBlock | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphJobAlert | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | ParagraphRelatedContentLoadMore | ParagraphDevelopmentBlock | ParagraphUpdates): ParsedParagraphText | ParsedParagraphCampaignManager | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlockPlain | ParsedParagraphGridBlocksImage | ParsedParagraph360BuildingBlock | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_block_plain_guard(t) ?
    paragraph_grid_block_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph360_building_block_guard(t) ?
    paragraph360_building_block_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_job_alert_guard(t) ?
    paragraph_job_alert_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_related_content_load_more_guard(t) ?
    paragraph_related_content_load_more_parser(t) :
  paragraph_development_block_guard(t) ?
    paragraph_development_block_parser(t) :
    paragraph_updates_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_case_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_case_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeCaseFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCampaignManager | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlockPlain | ParsedParagraphGridBlocksImage | ParsedParagraph360BuildingBlock | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates> =>
    List<ParsedParagraphText | ParsedParagraphCampaignManager | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlockPlain | ParsedParagraphGridBlocksImage | ParsedParagraph360BuildingBlock | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_case_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_case_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_case_parser = (t: NodeCase): ParsedNodeCase => ({
  ...node_base_parser(t),
  bundle: ((_: any): "case" => "case")(t.type),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_case_field_category_parser(t.field_category),
  field_icon: singular_required_entity_reference_revisions_paragraph_with_target_node_case_field_icon_parser(t.field_icon),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_case_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_case_field_page_content_parser(t.field_page_content)
})

export const node_case_guard = (t: Node): t is NodeCase => node_bundle_parser(t.type) == "case"

export const entity_reference_media_with_target_node_contact_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeContactFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_contact_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeContactFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_contact_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeContactFieldIntroductionImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_contact_field_introduction_image_item_guard(f[0]) ? entity_reference_media_with_target_node_contact_field_introduction_image_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeContactFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphOffice | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExtraNavigationalElement | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphMagazineEmbed | ParagraphMedia | ParagraphOffice | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphOffice | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_office_guard(t) ?
    paragraph_office_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeContactFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeContactFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphOffice | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphOffice | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_contact_parser = (t: NodeContact): ParsedNodeContact => ({
  ...node_base_parser(t),
  bundle: ((_: any): "contact" => "contact")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_optional_entity_reference_media_with_target_node_contact_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_contact_field_page_content_parser(t.field_page_content)
})

export const node_contact_guard = (t: Node): t is NodeContact => node_bundle_parser(t.type) == "contact"

export const entity_reference_taxonomy_term_with_target_node_expertise_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodeExpertiseFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_expertise_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodeExpertiseFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_expertise_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodeExpertiseFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_expertise_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_expertise_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_expertise_field_icon_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldIconItem): ParsedParagraphIcon | undefined | undefined => (t.target !== undefined ? ((t: ParagraphIcon): ParsedParagraphIcon =>
    paragraph_icon_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_expertise_field_icon_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldIconItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const singular_required_entity_reference_revisions_paragraph_with_target_node_expertise_field_icon_parser = (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldIconItem>): ParsedParagraphIcon | undefined => entity_reference_revisions_paragraph_with_target_node_expertise_field_icon_item_parser(f[0])

export const entity_reference_media_with_target_node_expertise_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeExpertiseFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_expertise_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeExpertiseFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_expertise_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeExpertiseFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_expertise_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphRelatedContentLoadMore | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphContact | ParagraphCampaignManager | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphMagazineEmbed | ParagraphMedia | ParagraphRelatedContentLoadMore | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | ParagraphUpdates | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphRelatedContentLoadMore | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_related_content_load_more_guard(t) ?
    paragraph_related_content_load_more_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_updates_guard(t) ?
    paragraph_updates_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeExpertiseFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphRelatedContentLoadMore | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphRelatedContentLoadMore | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_expertise_parser = (t: NodeExpertise): ParsedNodeExpertise => ({
  ...node_base_parser(t),
  bundle: ((_: any): "expertise" => "expertise")(t.type),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_expertise_field_category_parser(t.field_category),
  field_icon: singular_required_entity_reference_revisions_paragraph_with_target_node_expertise_field_icon_parser(t.field_icon),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_expertise_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_expertise_field_page_content_parser(t.field_page_content)
})

export const node_expertise_guard = (t: Node): t is NodeExpertise => node_bundle_parser(t.type) == "expertise"

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldIconsItem): ParsedParagraphIconWithText | undefined | undefined => (t.target !== undefined ? ((t: ParagraphIconWithText): ParsedParagraphIconWithText =>
    paragraph_icon_with_text_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldIconsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldIconsItem>): List<ParsedParagraphIconWithText> =>
    List<ParsedParagraphIconWithText>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_homepage_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_homepage_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_homepage_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_homepage_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem): ParsedParagraphText | ParsedParagraphAdressBlock | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphAdressBlock | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphImageGallery | ParagraphIframe | ParagraphIframeCode | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | ParagraphUpdates | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphAdressBlock | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_adress_block_guard(t) ?
    paragraph_adress_block_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_updates_guard(t) ?
    paragraph_updates_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphAdressBlock | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphAdressBlock | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_homepage_parser = (t: NodeHomepage): ParsedNodeHomepage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "homepage" => "homepage")(t.type),
  field_button: singular_optional_link_parser(t.field_button),
  field_icons: plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_icons_parser(t.field_icons),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_homepage_field_introduction_image_parser(t.field_introduction_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_parser(t.field_page_content)
})

export const node_homepage_guard = (t: Node): t is NodeHomepage => node_bundle_parser(t.type) == "homepage"

export const entity_reference_taxonomy_term_with_target_node_page_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodePageFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_page_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodePageFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_page_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodePageFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_page_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_page_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_page_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_page_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_page_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_page_field_introduction_image_item_guard(f[0]) ? entity_reference_media_with_target_node_page_field_introduction_image_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphJobAlert | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | ParagraphRelatedContentLoadMore | ParagraphDevelopmentBlock | ParagraphUpdates | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_job_alert_guard(t) ?
    paragraph_job_alert_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_related_content_load_more_guard(t) ?
    paragraph_related_content_load_more_parser(t) :
  paragraph_development_block_guard(t) ?
    paragraph_development_block_parser(t) :
  paragraph_updates_guard(t) ?
    paragraph_updates_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_page_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphJobAlert | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraphDevelopmentBlock | ParsedParagraphUpdates | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_page_parser = (t: NodePage): ParsedNodePage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "page" => "page")(t.type),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_page_field_category_parser(t.field_category),
  field_global_parent_page: singular_optional_string_parser(t.field_global_parent_page),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_optional_entity_reference_media_with_target_node_page_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_page_field_page_content_parser(t.field_page_content)
})

export const node_page_guard = (t: Node): t is NodePage => node_bundle_parser(t.type) == "page"

export const entity_reference_taxonomy_term_with_target_node_project_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodeProjectFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_project_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodeProjectFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_project_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodeProjectFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_project_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_project_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_project_field_icons_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldIconsItem): ParsedParagraphIconWithText | undefined | undefined => (t.target !== undefined ? ((t: ParagraphIconWithText): ParsedParagraphIconWithText =>
    paragraph_icon_with_text_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_project_field_icons_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldIconsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_project_field_icons_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldIconsItem>): List<ParsedParagraphIconWithText> =>
    List<ParsedParagraphIconWithText>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_project_field_icons_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_project_field_icons_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_project_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeProjectFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_project_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeProjectFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_project_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeProjectFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_project_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_project_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframeCode | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframeCode | ParagraphIframe | ParagraphImageGallery | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframeCode | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_project_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_project_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeProjectFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframeCode | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframeCode | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_project_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_project_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_project_parser = (t: NodeProject): ParsedNodeProject => ({
  ...node_base_parser(t),
  bundle: ((_: any): "project" => "project")(t.type),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_project_field_category_parser(t.field_category),
  field_icons: plural_entity_reference_revisions_paragraph_with_target_node_project_field_icons_parser(t.field_icons),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_project_field_introduction_image_parser(t.field_introduction_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_project_field_page_content_parser(t.field_page_content)
})

export const node_project_guard = (t: Node): t is NodeProject => node_bundle_parser(t.type) == "project"

export const entity_reference_media_with_target_node_story_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_story_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_story_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_story_field_introduction_image_item_guard(f[0]) ? entity_reference_media_with_target_node_story_field_introduction_image_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphCampaignManager | ParagraphContact | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksImage | ParagraphGridBlocksPlain | ParagraphImageGallery | ParagraphLinksList | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphTextWithImage | ParagraphTimeline | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_story_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphContact | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_story_parser = (t: NodeStory): ParsedNodeStory => ({
  ...node_base_parser(t),
  bundle: ((_: any): "story" => "story")(t.type),
  field_global_parent_page: singular_optional_string_parser(t.field_global_parent_page),
  field_introduction_image: singular_optional_entity_reference_media_with_target_node_story_field_introduction_image_parser(t.field_introduction_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_story_field_page_content_parser(t.field_page_content)
})

export const node_story_guard = (t: Node): t is NodeStory => node_bundle_parser(t.type) == "story"

export const entity_reference_taxonomy_term_with_target_node_update_field_category_item_parser = (t: EntityReferenceTaxonomyTermWithTargetNodeUpdateFieldCategoryItem): ParsedTaxonomyTermRelatedContent | undefined | undefined => (t.target !== undefined ? ((t: TaxonomyTermRelatedContent): ParsedTaxonomyTermRelatedContent =>
    taxonomy_term_related_content_parser(t))(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_node_update_field_category_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetNodeUpdateFieldCategoryItem => (t.target_id !== undefined)

export const plural_entity_reference_taxonomy_term_with_target_node_update_field_category_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetNodeUpdateFieldCategoryItem>): List<ParsedTaxonomyTermRelatedContent> =>
    List<ParsedTaxonomyTermRelatedContent>(f.filter(i => entity_reference_taxonomy_term_with_target_node_update_field_category_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_node_update_field_category_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_update_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeUpdateFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_update_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeUpdateFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_update_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeUpdateFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_update_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_update_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeUpdateFieldPageContentItem): ParsedParagraphText | ParsedParagraphContact | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraph360BuildingBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphContact | ParagraphCta | ParagraphCampaignManager | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExtraNavigationalElement | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphIframeCode | ParagraphImageGallery | ParagraphMagazineEmbed | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage | ParagraphRelatedContentLoadMore | Paragraph360BuildingBlock): ParsedParagraphText | ParsedParagraphContact | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraph360BuildingBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_campaign_manager_guard(t) ?
    paragraph_campaign_manager_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_iframe_code_guard(t) ?
    paragraph_iframe_code_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_magazine_embed_guard(t) ?
    paragraph_magazine_embed_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_with_image_guard(t) ?
    paragraph_quote_with_image_parser(t) :
  paragraph_related_content_load_more_guard(t) ?
    paragraph_related_content_load_more_parser(t) :
    paragraph360_building_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_update_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeUpdateFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_update_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeUpdateFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphContact | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraph360BuildingBlock> =>
    List<ParsedParagraphText | ParsedParagraphContact | ParsedParagraphCta | ParsedParagraphCampaignManager | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExtraNavigationalElement | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphIframeCode | ParsedParagraphImageGallery | ParsedParagraphMagazineEmbed | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | ParsedParagraphRelatedContentLoadMore | ParsedParagraph360BuildingBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_update_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_update_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_update_parser = (t: NodeUpdate): ParsedNodeUpdate => ({
  ...node_base_parser(t),
  bundle: ((_: any): "update" => "update")(t.type),
  field_category: plural_entity_reference_taxonomy_term_with_target_node_update_field_category_parser(t.field_category),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_update_field_introduction_image_parser(t.field_introduction_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_update_field_page_content_parser(t.field_page_content)
})

export const node_update_guard = (t: Node): t is NodeUpdate => node_bundle_parser(t.type) == "update"

export const entity_reference_media_with_target_node_update_overview_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeUpdateOverviewFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_update_overview_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeUpdateOverviewFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_update_overview_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeUpdateOverviewFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_update_overview_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeUpdateOverviewFieldPageContentOptionalItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphContact | ParagraphDoubleTextWithImage | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphExtraNavigationalElement | ParagraphForm | ParagraphGridBlocksImage | ParagraphGridBlocksPlain | ParagraphImageGallery | ParagraphLinksList | ParagraphMedia | ParagraphPress | ParagraphQuote | ParagraphQuoteWithImage): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_contact_guard(t) ?
    paragraph_contact_parser(t) :
  paragraph_double_text_with_image_guard(t) ?
    paragraph_double_text_with_image_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_extra_navigational_element_guard(t) ?
    paragraph_extra_navigational_element_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_press_guard(t) ?
    paragraph_press_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
    paragraph_quote_with_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeUpdateOverviewFieldPageContentOptionalItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeUpdateOverviewFieldPageContentOptionalItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphContact | ParsedParagraphDoubleTextWithImage | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphExtraNavigationalElement | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphPress | ParsedParagraphQuote | ParsedParagraphQuoteWithImage>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_item_parser(i)).filter(i => i !== undefined))

export const node_update_overview_parser = (t: NodeUpdateOverview): ParsedNodeUpdateOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "update_overview" => "update_overview")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_update_overview_field_introduction_image_parser(t.field_introduction_image),
  field_links: plural_link_parser(t.field_links),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content_optional: plural_entity_reference_revisions_paragraph_with_target_node_update_overview_field_page_content_optional_parser(t.field_page_content_optional)
})

export const node_update_overview_guard = (t: Node): t is NodeUpdateOverview => node_bundle_parser(t.type) == "update_overview"

export const node_parser = (t: Node): ParsedNode =>
  node_career_guard(t) ?
    node_career_parser(t) :
  node_case_guard(t) ?
    node_case_parser(t) :
  node_contact_guard(t) ?
    node_contact_parser(t) :
  node_expertise_guard(t) ?
    node_expertise_parser(t) :
  node_homepage_guard(t) ?
    node_homepage_parser(t) :
  node_page_guard(t) ?
    node_page_parser(t) :
  node_project_guard(t) ?
    node_project_parser(t) :
  node_story_guard(t) ?
    node_story_parser(t) :
  node_update_guard(t) ?
    node_update_parser(t) :
    node_update_overview_parser(t)

export const node_guard = (t: Entity): t is Node => (
  (t as any).nid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "node_type" &&
  (t as any).revision_timestamp !== undefined &&
  (t as any).revision_uid !== undefined &&
  (t as any).revision_log !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).title !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).promote !== undefined &&
  (t as any).sticky !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).moderation_state !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined &&
  (t as any).content_translation_source !== undefined &&
  (t as any).content_translation_outdated !== undefined
)

export const entity_reference_config_pages_type_item_parser = (t: EntityReferenceConfigPagesTypeItem): ParsedEntityReferenceConfigPagesTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_optional_entity_reference_config_pages_type_parser = (f: FieldItemList<EntityReferenceConfigPagesTypeItem>): ParsedEntityReferenceConfigPagesTypeItem | null => f && f.length > 0 ? entity_reference_config_pages_type_item_parser(f[0]) : null

export const config_pages_bundle_parser = (f: FieldItemList<EntityReferenceConfigPagesTypeItem>): string => f[0].target_id

export const config_pages_base_parser = (t: ConfigPagesBase): ParsedConfigPagesBase => ({
  entity_type: ((_: any): "config_pages" => "config_pages")(t),
  id: singular_optional_integer_parser(t.id),
  label: singular_optional_string_parser(t.label),
  context: singular_optional_string_long_parser(t.context),
  changed: singular_optional_changed_parser(t.changed),
  metatag: metatag_field_parser(t.metatag),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const config_pages_cookiebar_parser = (t: ConfigPagesCookiebar): ParsedConfigPagesCookiebar => ({
  ...config_pages_base_parser(t),
  bundle: ((_: any): "cookiebar" => "cookiebar")(t.type),
  field_accept_button_text: singular_required_string_parser(t.field_accept_button_text),
  field_cookie_text: singular_required_text_long_parser(t.field_cookie_text),
  field_decline_button_text: singular_optional_string_parser(t.field_decline_button_text)
})

export const config_pages_cookiebar_guard = (t: ConfigPages): t is ConfigPagesCookiebar => config_pages_bundle_parser(t.type) == "cookiebar"

export const config_pages_footer_parser = (t: ConfigPagesFooter): ParsedConfigPagesFooter => ({
  ...config_pages_base_parser(t),
  bundle: ((_: any): "footer" => "footer")(t.type),
  field_image: singular_required_image_file_with_target_parser(t.field_image)
})

export const config_pages_footer_guard = (t: ConfigPages): t is ConfigPagesFooter => config_pages_bundle_parser(t.type) == "footer"

export const config_pages_press_parser = (t: ConfigPagesPress): ParsedConfigPagesPress => ({
  ...config_pages_base_parser(t),
  bundle: ((_: any): "press" => "press")(t.type),
  field_designation: singular_optional_string_parser(t.field_designation),
  field_e_mail: plural_email_parser(t.field_e_mail),
  field_introduction: singular_required_text_long_parser(t.field_introduction),
  field_label: singular_optional_string_parser(t.field_label),
  field_name: singular_required_string_parser(t.field_name),
  field_phone_number: plural_telephone_parser(t.field_phone_number)
})

export const config_pages_press_guard = (t: ConfigPages): t is ConfigPagesPress => config_pages_bundle_parser(t.type) == "press"

export const config_pages_press_dutch_parser = (t: ConfigPagesPressDutch): ParsedConfigPagesPressDutch => ({
  ...config_pages_base_parser(t),
  bundle: ((_: any): "press_dutch" => "press_dutch")(t.type),
  field_designation: singular_optional_string_parser(t.field_designation),
  field_e_mail: plural_email_parser(t.field_e_mail),
  field_introduction: singular_required_text_long_parser(t.field_introduction),
  field_label: singular_optional_string_parser(t.field_label),
  field_name: singular_required_string_parser(t.field_name),
  field_phone_number: plural_telephone_parser(t.field_phone_number)
})

export const config_pages_press_dutch_guard = (t: ConfigPages): t is ConfigPagesPressDutch => config_pages_bundle_parser(t.type) == "press_dutch"

export const singular_required_integer_parser = (f: FieldItemList<IntegerItem>): number => integer_item_parser(f[0])

export const config_pages_preview_link_parser = (t: ConfigPagesPreviewLink): ParsedConfigPagesPreviewLink => ({
  ...config_pages_base_parser(t),
  bundle: ((_: any): "preview_link" => "preview_link")(t.type),
  field_field_days_valid: singular_required_integer_parser(t.field_field_days_valid)
})

export const config_pages_preview_link_guard = (t: ConfigPages): t is ConfigPagesPreviewLink => config_pages_bundle_parser(t.type) == "preview_link"

export const config_pages_parser = (t: ConfigPages): ParsedConfigPages =>
  config_pages_cookiebar_guard(t) ?
    config_pages_cookiebar_parser(t) :
  config_pages_footer_guard(t) ?
    config_pages_footer_parser(t) :
  config_pages_press_guard(t) ?
    config_pages_press_parser(t) :
  config_pages_press_dutch_guard(t) ?
    config_pages_press_dutch_parser(t) :
    config_pages_preview_link_parser(t)

export const config_pages_guard = (t: Entity): t is ConfigPages => (
  (t as any).id !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).label !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "config_pages_type" &&
  (t as any).context !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).metatag !== undefined
)

export const input_entity_parser = (t: InputEntity): ParsedInputEntity =>
  node_guard(t) ?
    node_parser(t) :
  taxonomy_term_guard(t) ?
    taxonomy_term_parser(t) :
    config_pages_parser(t)

export const entity_parser = (t: Entity): ParsedEntity =>
  node_guard(t) ?
    node_parser(t) :
  taxonomy_term_guard(t) ?
    taxonomy_term_parser(t) :
  media_guard(t) ?
    media_parser(t) :
  file_guard(t) ?
    file_parser(t) :
  paragraph_guard(t) ?
    paragraph_parser(t) :
    config_pages_parser(t)

export const input_entity_guard = (t: any): t is InputEntity => (
  node_guard(t as InputEntity) ||
  taxonomy_term_guard(t as InputEntity) ||
  config_pages_guard(t as InputEntity)
)

export const entity_guard = (t: any): t is Entity => (
  node_guard(t as Entity) ||
  taxonomy_term_guard(t as Entity) ||
  media_guard(t as Entity) ||
  file_guard(t as Entity) ||
  paragraph_guard(t as Entity) ||
  config_pages_guard(t as Entity)
)